module.exports = __webpack_public_path__ + "img/office.bbf319e1.png";